import React from "react";
import { AppIcons } from "../../../../data/appIcons";
import Image from "../../../image/Image";
import "./NoRecordFound.scss";

const NoRecordFound = () => {
  return (
    <div className="record-not-found">
      <Image imagePath={AppIcons.noRecordImg} altText="Record Not Found" />
      <h5>No Record Found</h5>
    </div>
  );
}

export default NoRecordFound;
